import { createModuleApi } from '@wit-support/admin-client-core';
const api = createModuleApi({ errorFormat: 'raw' });
export function setBlacklistApiBaseUrl(url) {
    api.setBaseUrl(url);
}
/** Newest-first blacklist entries. */
export async function listBlacklist() {
    return api.get('/api/blacklist');
}
/** Add an email to the blacklist (idempotent upsert server-side). */
export async function addToBlacklist(body) {
    await api.post('/api/blacklist', body);
}
/** Remove an email from the blacklist (unblock). */
export async function removeFromBlacklist(email) {
    const r = await api.del(`/api/blacklist/${encodeURIComponent(email)}`);
    if (!r.ok) {
        throw new Error(`request failed ${r.status}: ${(await r.text().catch(() => '')) || r.statusText}`);
    }
}
//# sourceMappingURL=api.js.map